import React, { useEffect, useState } from "react";
import { components, MenuListProps, SelectInstance } from "react-select";
import CreatableSelect from "react-select/creatable";
import AsyncCreatableSelect from "react-select/async-creatable";
import { useField } from "formik";

// old theme colors
// theme={(theme) => ({
//   ...theme,
//   colors: {
//     ...theme.colors,
//     primary: "#ebf2fe", //active
//     primary25: "#f1f6fe", //hover
//     primary50: "#f1f6fe", //clicable
//   },
// })}

interface CreatablePropsType {
  customMenuList?: (props: MenuListProps) => JSX.Element;
  id: string;
  className?: string;
  placeholder?: string;
  FieldName: string;
  name?: string;
  options: Array<any>;
  isDisabled?: boolean;
  onCreateOption?: any;
  handleChange: any;
  Value: any;
  changeValuePerameter?: any;
  defaultValue?: any;
  onClear?: any;
  isNotCreatable?: boolean;
  CustomOptionComponent?: any;
  isClearable?: boolean;
  CustomFilterOption?: any;
  menuPortalTarget?: any;
  isSearchable?: boolean;
  autoFocus?: boolean;
  optionInnerWidth?: any;
  isInnerWidth?: any;
  defaultOptions?: any;
  onBlur?: any;
  tabIndex?: number;
  tabSelectsValue?: boolean;
  openMenuOnFocus?: boolean;
  onFocus?: any;
  ref?: null;
}

interface AsyncCreatablePropsType {
  id?: string;
  className?: string;
  placeholder?: string;
  FieldName: string;
  name?: string;
  options?: Array<any>;
  loadOptions?: any;
  isDisabled?: boolean;
  disabled?: boolean;
  menuPlacement?: any;
  onCreateOption?: any;
  handleChange?: any;
  onChange?: (e: any, newValue?: any) => void;
  Value: any;
  value?: any;
  changeValuePerameter?: any;
  onClear?: any;
  isNotCreatable?: boolean;
  CustomOptionComponent?: any;
  customMenuList?: (props: MenuListProps) => JSX.Element;
  isClearable?: boolean;
  CustomFilterOption?: any;
  menuPortalTarget?: any;
  isSearchable?: boolean;
  noOptionsMessage?: any;
  onInputChange?: any;
  defaultOptions?: any;
  autoFocus?: any;
  optionInnerWidth?: any;
  isInnerWidth?: any;
  onBlur?: any;
  onFocus?: any;
  tabIndex?: number;
  openMenuOnFocus?: boolean;
  tabSelectsValue?: boolean;
  ref?: any;
  label?: string;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  getOptionLabel?: (option: any) => string;
  getOptionValue?: (option: any) => any;
  inputValue?: string;
}

const Option = (props: any) => {
  return (
    <components.Option {...props}>
      {/* custom html here for option  */}
      <div> {props.children}</div>
    </components.Option>
  );
};

const MenuList = (props: MenuListProps) => {
  return <components.MenuList {...props}>{props.children}</components.MenuList>;
};

const ValueContainer = (props: any) => {
  return (
    <components.ValueContainer {...props}>
      <components.Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </components.Placeholder>
      {React.Children.map(props.children, (child) =>
        child && child.type !== components.Placeholder ? child : null
      )}
    </components.ValueContainer>
  );
};

const filterOption = (candidate: any, input: any) => {
  return (
    candidate.data.__isNew__ ||
    candidate.label.toLowerCase().includes(input.toLowerCase().trim())
  );
};

const CustomInput = (props: any) => {
  return <components.Input {...props} autoComplete="new-password" />;
};

export const CustomSelect = (props: CreatablePropsType) => {
  const {
    FieldName,
    options,
    handleChange,
    Value,
    changeValuePerameter,
    onClear,
    isNotCreatable,
    CustomOptionComponent,
    CustomFilterOption,
    placeholder,
    onBlur,
    ...restProps
  } = props;

  let valueChangePerameter = changeValuePerameter ? changeValuePerameter : "";
  const [defaultValue, setDefaultValue] = useState<any>(null);
  const [field, meta, helpers] = useField(`${FieldName}`);

  useEffect((): void => {
    const value = options?.find((item) => item.value === Value);
    if (value) setDefaultValue(value);
    else setDefaultValue(null);
  }, [options, valueChangePerameter, Value]);

  if (!isNotCreatable) {
    return (
      <CreatableSelect
        {...field}
        {...restProps}
        inputId={restProps.id}
        // menuPlacement="auto"
        tabSelectsValue
        onBlur={onBlur ? onBlur : null}
        placeholder={placeholder ? placeholder : ""}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: "#5156be", //active
            primary25: "#7278e9", //hover
            primary50: "#25258f", //clicable
          },
        })}
        onChange={(e, ActionType) => {
          if (ActionType.action === "clear") {
            helpers.setValue(null);
            setDefaultValue(null);
            handleChange({ value: null });
            if (props.onClear) {
              onClear();
            }
          } else {
            handleChange(e);
          }
        }}
        components={{
          Option: CustomOptionComponent ? CustomOptionComponent : Option,
          ValueContainer: ValueContainer,
          Input: CustomInput,
          MenuList: props?.customMenuList || MenuList,
        }}
        options={options}
        value={defaultValue}
        styles={selectStyles(meta, props)}
        filterOption={CustomFilterOption ? CustomFilterOption : filterOption}
      />
    );
  } else {
    return (
      <CreatableSelect
        {...field}
        {...restProps}
        inputId={restProps.id}
        onBlur={onBlur ? onBlur : null}
        isValidNewOption={() => false}
        // menuPlacement="auto"
        tabSelectsValue
        placeholder={placeholder ? placeholder : ""}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: "#5156be", //active
            primary25: "#7278e9", //hover
            primary50: "#25258f", //clicable
          },
        })}
        onChange={(e, ActionType) => {
          if (ActionType.action === "clear") {
            helpers.setValue(null);
            setDefaultValue(null);
            handleChange({ value: null });
            if (props.onClear) {
              onClear();
            }
          } else {
            handleChange(e);
          }
        }}
        components={{
          Option: CustomOptionComponent ? CustomOptionComponent : Option,
          ValueContainer: ValueContainer,
          Input: CustomInput,
          MenuList: props?.customMenuList || MenuList,
        }}
        options={options}
        value={defaultValue}
        styles={selectStyles(meta, props)}
        filterOption={CustomFilterOption ? CustomFilterOption : filterOption}
      />
    );
  }
};

export const AsyncCustomSelect = (props: AsyncCreatablePropsType) => {
  const {
    FieldName,
    handleChange,
    Value,
    options,
    changeValuePerameter,
    isNotCreatable,
    CustomOptionComponent,
    CustomFilterOption,
    placeholder,
    onBlur,
    ...restProps
  } = props;

  let valueChangePerameter = changeValuePerameter ? changeValuePerameter : "";
  const [defaultValue, setDefaultValue] = useState<any>(null);
  const [field, meta, helpers] = useField(`${FieldName}`);

  useEffect((): void => {
    const value = options?.find((item) => item.value === Value);
    if (value) setDefaultValue(value);
    else setDefaultValue(null);
  }, [options, valueChangePerameter, Value]);

  if (!isNotCreatable) {
    return (
      <AsyncCreatableSelect
        {...field}
        {...restProps}
        onBlur={onBlur ? onBlur : null}
        inputId={restProps.id}
        // menuPlacement="auto"
        placeholder={placeholder ? placeholder : ""}
        cacheOptions
        tabSelectsValue
        // isOptionDisabled={(option)=> option?.isDisabled === true}
        options={options}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: "#5156be", //active
            primary25: "#7278e9", //hover
            primary50: "#25258f", //clicable
          },
        })}
        onChange={(e, ActionType) => {
          if (ActionType.action === "clear") {
            if (props.onClear) {
              props.onClear();
            }
            handleChange({ value: null });
            setDefaultValue(null);
            helpers.setValue(null);
          } else {
            handleChange(e);
          }
        }}
        value={defaultValue}
        styles={selectStyles(meta, props)}
        components={{
          Option: CustomOptionComponent ? CustomOptionComponent : Option,
          ValueContainer: ValueContainer,
          Input: CustomInput,
          MenuList: props?.customMenuList || MenuList,
        }}
        filterOption={CustomFilterOption ? CustomFilterOption : filterOption}
      />
    );
  } else {
    return (
      <AsyncCreatableSelect
        {...field}
        // menuPlacement="auto"
        {...restProps}
        onBlur={onBlur ? onBlur : null}
        inputId={restProps.id}
        placeholder={placeholder ? placeholder : ""}
        cacheOptions
        tabSelectsValue
        isValidNewOption={() => false}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: "#5156be", //active
            primary25: "#7278e9", //hover
            primary50: "#25258f", //clicable
          },
        })}
        onChange={(e, ActionType) => {
          if (ActionType.action === "clear") {
            if (props.onClear) {
              props.onClear();
            }
            handleChange({ value: null });
            setDefaultValue(null);
            helpers.setValue(null);
          } else {
            handleChange(e);
          }
        }}
        value={defaultValue}
        styles={selectStyles(meta, props)}
        components={{
          Option: CustomOptionComponent ? CustomOptionComponent : Option,
          ValueContainer: ValueContainer,
          Input: CustomInput,
          MenuList: props?.customMenuList || MenuList,
        }}
        filterOption={CustomFilterOption ? CustomFilterOption : filterOption}
      />
    );
  }
};

export const AsyncSelect = (props: AsyncCreatablePropsType) => {
  const {
    FieldName,
    handleChange,
    Value,
    options,
    changeValuePerameter,
    isNotCreatable,
    CustomOptionComponent,
    CustomFilterOption,
    placeholder,
    onBlur,
    ...restProps
  } = props;

  const [field, meta, helpers] = useField(`${FieldName}`);

  return (
    <AsyncCreatableSelect
      {...field}
      {...restProps}
      onBlur={onBlur ? onBlur : null}
      inputId={restProps.id}
      placeholder={placeholder ? placeholder : ""}
      cacheOptions
      tabSelectsValue
      openMenuOnFocus={false}
      isValidNewOption={() => false}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: "#5156be", //active
          primary25: "#7278e9", //hover
          primary50: "#25258f", //clicable
        },
      })}
      onChange={(e, ActionType) => {
        if (ActionType.action === "clear") {
          if (props.onClear) {
            props.onClear();
          }
          handleChange({ value: null });
          helpers.setValue(null);
        } else {
          handleChange(e);
        }
      }}
      value={Value}
      styles={selectStyles(meta, props)}
      components={{
        Option: CustomOptionComponent ? CustomOptionComponent : Option,
        ValueContainer: ValueContainer,
        Input: CustomInput,
        MenuList: props?.customMenuList || MenuList,
      }}
      filterOption={CustomFilterOption ? CustomFilterOption : filterOption}
    />
  );
};

export const SimpleCreatableAsyncSelect = (props: AsyncCreatablePropsType) => {
  const {
    handleChange,
    Value,
    options,
    changeValuePerameter,
    CustomOptionComponent,
    CustomFilterOption,
    placeholder,
    onBlur,
    ...restProps
  } = props;
  return (
    <AsyncCreatableSelect
      {...restProps}
      onBlur={onBlur ? onBlur : null}
      inputId={restProps.id}
      placeholder={placeholder ? placeholder : ""}
      cacheOptions
      tabSelectsValue
      openMenuOnFocus={false}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: "#5156be", //active
          primary25: "#7278e9", //hover
          primary50: "#25258f", //clicable
        },
      })}
      onChange={(e, ActionType) => {
        if (ActionType.action === "clear") {
          if (props.onClear) {
            props.onClear();
          }
          handleChange({ value: null });
        } else {
          handleChange(e);
        }
      }}
      value={Value}
      styles={selectStyles(null, props)}
      components={{
        Option: CustomOptionComponent ? CustomOptionComponent : Option,
        ValueContainer: ValueContainer,
        Input: CustomInput,
        MenuList: props?.customMenuList || MenuList,
      }}
      filterOption={CustomFilterOption ? CustomFilterOption : filterOption}
    />
  );
};

export const SimpleAsyncSelect = (props: AsyncCreatablePropsType) => {
  const {
    handleChange,
    Value,
    options,
    changeValuePerameter,
    CustomOptionComponent,
    CustomFilterOption,
    placeholder,
    onBlur,
    ...restProps
  } = props;
  return (
    <AsyncCreatableSelect
      {...restProps}
      onBlur={onBlur ? onBlur : null}
      inputId={restProps.id}
      placeholder={placeholder ? placeholder : ""}
      isValidNewOption={() => false}
      cacheOptions
      tabSelectsValue
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: "#5156be", //active
          primary25: "#7278e9", //hover
          primary50: "#25258f", //clicable
        },
      })}
      onChange={(e, ActionType) => {
        if (ActionType.action === "clear") {
          if (props.onClear) {
            props.onClear();
          }
          handleChange({ value: null });
        } else {
          handleChange(e);
        }
      }}
      value={Value}
      openMenuOnFocus={false}
      styles={selectStyles(null, props)}
      components={{
        Option: CustomOptionComponent ? CustomOptionComponent : Option,
        ValueContainer: ValueContainer,
        Input: CustomInput,
        MenuList: props?.customMenuList || MenuList,
      }}
      filterOption={CustomFilterOption ? CustomFilterOption : filterOption}
    />
  );
};

export const CustomSimpleSelect = (props: CreatablePropsType) => {
  const {
    FieldName,
    handleChange,
    Value,
    changeValuePerameter,
    onClear,
    isNotCreatable,
    CustomOptionComponent,
    CustomFilterOption,
    placeholder,
    onBlur,
    ...restProps
  } = props;
  const [defaultValue, setDefaultValue] = useState<any>(null);
  useEffect((): void => {
    const value = props?.options?.find((item) => item.value === Value);
    if (value) setDefaultValue(value);
    else setDefaultValue(null);
  }, [props?.options, Value]);
  return (
    <CreatableSelect
      {...restProps}
      menuPlacement="auto"
      minMenuHeight={200}
      onBlur={onBlur ? onBlur : null}
      inputId={restProps.id}
      value={defaultValue}
      blurInputOnSelect={false}
      openMenuOnFocus={false}
      isValidNewOption={(inputValue, selectValue, selectOptions) => {
        if (isNotCreatable) {
          return false;
        } else {
          return (
            (inputValue &&
              !selectOptions.some(
                (option) =>
                  option.label.toLowerCase() === inputValue.toLowerCase()
              )) ||
            false
          );
        }
      }}
      placeholder={placeholder ? placeholder : ""}
      tabSelectsValue={false}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: "#5156be", //active
          primary25: "#7278e9", //hover
          primary50: "#25258f", //clicable
        },
      })}
      onChange={(e) => {
        handleChange(e);
      }}
      styles={selectStyles(null, props)}
      components={{
        Option: CustomOptionComponent ? CustomOptionComponent : Option,
        ValueContainer: ValueContainer,
        Input: CustomInput,
        MenuList: props?.customMenuList || MenuList,
      }}
    />
  );
};

const CustomAsyncSelect = React.forwardRef<SelectInstance<any>, AsyncCreatablePropsType>(
  (props, ref) => {
    const {
      FieldName,
      handleChange,
      onChange,
      changeValuePerameter,
      onClear,
      isNotCreatable,
      CustomOptionComponent,
      placeholder,
      onBlur,
      ...restProps
    } = props;

    const [field, meta, helpers] = useField(`${FieldName}`);
    
    const handleChangeWrapper = (e: any) => {
      // Call handleChange if provided (old behavior)
      if (handleChange) {
        handleChange(e);
      }
      // Call onChange if provided (new behavior matching react-select)
      if (onChange) {
        onChange(e, e);
      }
    };
    
    return (
      <AsyncCreatableSelect
        {...restProps}
        {...field}
        menuPlacement="auto"
        minMenuHeight={200}
        onBlur={onBlur ? onBlur : null}
        inputId={restProps.id}
        value={props.Value || null}
        blurInputOnSelect={false}
        openMenuOnFocus={false}
        isValidNewOption={(inputValue, selectValue, selectOptions) => {
          if (isNotCreatable) {
            return false;
          } else {
            return (
            (inputValue &&
              !selectOptions.some(
                (option) =>
                  option.label.toLowerCase() === inputValue.toLowerCase()
              )) ||
            false
          );
        }
      }}
      placeholder={placeholder ? placeholder : ""}
      cacheOptions
      tabSelectsValue={false}
      ref={ref}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: "#5156be", //active
          primary25: "#7278e9", //hover
          primary50: "#25258f", //clicable
        },
      })}
      onChange={handleChangeWrapper}
      styles={selectStyles(meta, props as any)}
      components={{
        Option: CustomOptionComponent ? CustomOptionComponent : Option,
        ValueContainer: ValueContainer,
        Input: CustomInput,
        MenuList: props.customMenuList || MenuList,
      }}
    />
  );
});

CustomAsyncSelect.displayName = 'CustomAsyncSelect';

export { CustomAsyncSelect };

const selectStyles = (meta: any, props: any) => {
  const isDark =
    typeof document !== "undefined" &&
    document.documentElement.getAttribute("data-theme") === "dark";
  const textColor = isDark ? "#F1F5F9" : "black";
  const mutedColor = isDark ? "#94A3B8" : "gray";
  const surfaceColor = isDark ? "#151C26" : "white";
  const controlBg = isDark ? "#0B0F14" : undefined;
  const menuBg = isDark ? "#151C26" : undefined;
  const optionBorder = isDark ? "1px solid #1B2430" : "1px solid #f1f6fe";
  const controlBorder = isDark ? "1px solid #293241" : "1px solid $grey-100";
  const controlBorderFocus = isDark ? "1px solid #6366F1" : "1px solid black";
  const indicatorHover = isDark ? "#F1F5F9" : "black";

  return {
    control: (basestyle: any, state: any) => ({
      ...basestyle,
      backgroundColor: controlBg || basestyle.backgroundColor,
      color: isDark ? textColor : basestyle.color,
      border:
        meta?.error && meta?.touched
          ? state?.isFocused
            ? "1px solid #d32f2f"
            : "1px solid #d32f2f"
          : state?.isFocused
            ? controlBorderFocus
            : controlBorder,
      boxShadow: "none",
      "&:hover": {
        border:
          meta?.error && meta?.touched
            ? "1px solid #d32f2f"
            : controlBorderFocus,
      },
    }),
    placeholder: (basestyle: any, state: any) => ({
      ...basestyle,
      color:
        meta?.error && meta?.touched
          ? "#d32f2f"
          : state.hasValue || state.selectProps.inputValue
            ? state.isFocused
              ? isDark
                ? "#818CF8"
                : "#25258f"
              : mutedColor
            : mutedColor,
      overflow: "hidden",
      backgroundColor:
        state.hasValue || state.selectProps.inputValue
          ? surfaceColor
          : "transparant",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      position:
        state.hasValue || state.selectProps.inputValue ? "absolute" : "static",
      top: state.hasValue || state.selectProps.inputValue ? -15 : "10%",
      transition: "top 0.3s, font-size 0.1s",
      fontSize: (state.hasValue || state.selectProps.inputValue) && 10,
      paddingLeft:
        state.hasValue || state.selectProps.inputValue ? "3px" : "0px",
      paddingRight:
        state.hasValue || state.selectProps.inputValue ? "3px" : "0px",
    }),
    option: (basestyle: any, state: any) => ({
      ...basestyle,
      backgroundColor: isDark
        ? state.isSelected
          ? "#6366F1"
          : state.isFocused
            ? "#1B2430"
            : "#151C26"
        : basestyle.backgroundColor,
      border: optionBorder,
      color: state.data?.isDisabled ? "red" :
        state.data?.isUnique
          ? isDark ? "#818CF8" : "#5156BE"
          : state.isSelected
            ? "white"
            : state?.isFocused
              ? "white"
              : textColor,
    }),
    singleValue: (base: any) => ({
      ...base,
      color: isDark ? textColor : base.color,
      backgroundColor: "transparent",
      marginLeft: 2,
      paddingLeft: 2,
    }),
    input: (base: any) => ({
      ...base,
      color: isDark ? textColor : base.color,
      background: "transparent",
      backgroundColor: "transparent",
      boxShadow: "none",
    }),
    valueContainer: (provided: any, state: any) => ({
      ...provided,
      overflow:
        state.hasValue || state.selectProps.inputValue ? "visible" : "hidden",
      paddingLeft: 8,
      paddingRight: 8,
    }),
    dropdownIndicator: (base: any, state: any) => ({
      ...base,
      color: meta?.error && meta?.touched ? "#d32f2f" : "#adb5bd",
      "&:hover": {
        color: meta?.error && meta?.touched ? "#d32f2f" : indicatorHover,
      },
    }),
    menu: (base: any, state: any) => ({
      ...base,
      backgroundColor: menuBg || base.backgroundColor,
      color: isDark ? textColor : base.color,
      width: props?.isInnerWidth ? props?.optionInnerWidth : "100% !important",
    }),
    indicatorSeparator: (base: any, state: any) => ({
      ...base,
      backgroundColor: meta?.error && meta?.touched ? "#d32f2f" : "#adb5bd",
    }),
    clearIndicator: (base: any, state: any) => ({
      ...base,
      color: meta?.error && meta?.touched ? "#d32f2f" : "#adb5bd",
      "&:hover": {
        color: meta?.error && meta?.touched ? "#d32f2f" : indicatorHover,
      },
    }),
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
  };
};
